import { baseApi } from 'api/base';
import { FileType } from 'types/types';
import { fileApi } from 'api/file';
import { MovementData, PharmPermissionDTO } from '../types/types';
import { PharmPermissionPdf } from './params';

const createCard = async (data: PharmPermissionDTO<FileType>): Promise<string> => {
  const res = await baseApi.post('/pharm-permissions', data);
  return res.data.id;
};

const updateCard = async (data: PharmPermissionDTO<FileType>): Promise<string> => {
  const res = await baseApi.put('/pharm-permissions', data);
  return res.data.id;
};

const getCard = async (id: string): Promise<PharmPermissionDTO<FileType>> => {
  const res = await baseApi.get(`/pharm-permissions/${id}`);

  return res.data;
};

const getDefaultCard = async (): Promise<PharmPermissionDTO<FileType>> => {
  const res = await baseApi.get('/pharm-permissions/default-card');

  return res.data;
};

const deleteCard = async (id: string) => {
  await baseApi.delete(`/pharm-permissions/${id}`);
};

const getPdf = async (data: PharmPermissionPdf) =>
  baseApi
    .post(`/pharm-permissions/${data.id}/pharm-permission-report/generate`, data, {
      responseType: 'blob',
    })
    .then(fileApi.downloadFile);

const createMovement = async (data: MovementData<FileType>, id: string): Promise<string> => {
  const res = await baseApi.post(`/pharm-permissions/${id}/movement`, data);
  return res.data;
};

const deleteMovement = async (id: string, movementId: string) => {
  await baseApi.delete(`/pharm-permissions/${id}/movement/${movementId}`);
};

export const pharmPermissionsApi = {
  createCard,
  updateCard,
  getCard,
  getDefaultCard,
  deleteCard,
  getPdf,
  createMovement,
  deleteMovement,
};
